<template lang="html">
<div>
  <toolbar title="Users">
    <v-icon @click="loadUsers">refresh</v-icon>
  </toolbar>
  <v-layout column>
    <div class="pt-3">
      <v-card>
        <v-card-title>
          <v-layout row wrap align-end>
            <v-flex xs6></v-flex>
            <v-flex xs6>
              <v-text-field v-model="search" append-icon="search"
                            label="Search users" single-line hide-details>
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-data-table :headers="headers"
                      disable-initial-sort
                      must-sort
                      :items="users"
                      :search="search"
                      :rows-per-page-items="[10,20,30]">
          <template slot="items" slot-scope="slotItems">
            <tr @click="slotItems.expanded = !slotItems.expanded" class="cursor-pointer">
              <td>
                {{slotItems.item.id}}
              </td>
              <td>
                {{slotItems.item.name}}
              </td>
              <td>
                {{slotItems.item.contactEmail}}
              </td>
              <td>
                {{slotItems.item.roles.join(',')}}
              </td>
              <td>
                <v-btn color="accent"
                       v-if="!hasAdminRole(slotItems.item)"
                       @click.stop="toggleAdminRole(slotItems.item)">
                  Add LTN_ADMIN Role
                </v-btn>
                <v-btn v-if="hasAdminRole(slotItems.item)"
                     @click.stop="toggleAdminRole(slotItems.item)">
                  Remove LTN_ADMIN Role
                </v-btn>
                <v-btn flat class="text-capitalize"
                       :to="{ name: 'notification-settings',
                 params: { authProviderId: slotItems.item.authProviderId }}">
                  Notifications Settings
                </v-btn>
                <v-btn flat class="text-capitalize"
                       :to="{ name: 'profile',
                       params: { userId: slotItems.item.id }}">
                  Profile
                </v-btn>
                <v-btn flat
                       @click.prevent.stop="switchUser(slotItems.item)"
                       class="text-capitalize">
                  Switch to this User
                </v-btn>
                <v-btn flat
                       @click.prevent.stop="sendPasswordEmail(slotItems.item)"
                       class="text-capitalize">
                  Send reset password email
                </v-btn>
              </td>
            </tr>
          </template>
          <template slot="expand" slot-scope="slotItems">
            <user-expand :user-id="slotItems.item.id"></user-expand>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-layout>
  </div>
</template>

<script>
import _ from 'lodash';
import firebase from 'firebase';
import API from '@/api';
import Toolbar from '@/components/Toolbar';
import * as types from '@/store/mutationTypes';
import { UserRole } from '@/types';
import UserExpand from '@/components/UserExpand';

export default {
  name: 'UsersList',
  data: () => ({
    users: [],
    search: '',
    loadingBtn: false,
    headers: [
      { text: 'Id', value: 'id', sortable: true },
      { text: 'Name', value: 'name', sortable: true },
      { text: 'Contact Email', value: 'contactEmail', sortable: true },
      { text: 'Roles', value: 'roles', sortable: false },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
  }),
  components: {
    Toolbar,
    UserExpand,
  },
  methods: {
    async sendPasswordEmail(userItem) {
      this.$store.commit(`applications/${types.START_LOADING}`);
      try {
        await firebase.auth().sendPasswordResetEmail(userItem.contactEmail);
        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Email sent',
          timeout: 7000,
        });
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: 'An error occurred, please try again later',
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    async switchUser(userItem) {
      this.$store.commit(`applications/${types.START_LOADING}`);
      try {
        const response = await API.user.switchUser({ authProviderId: userItem.authProviderId });
        firebase.auth().signInWithCustomToken(response.data.jwt);
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: 'An error occurred, please try again later',
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    async loadUsers() {
      this.$store.commit(`applications/${types.START_LOADING}`);
      try {
        const response = await API.user.getUsers();
        this.users = response.data.users;
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: 'An error occurred, please try again later',
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    hasAdminRole(user) {
      return _.includes(user.roles, UserRole.ROLE_LTN_ADMIN);
    },
    async toggleAdminRole(user) {
      this.loadingBtn = true;

      try {
        await API.user.setRoles({
          userAuthId: user.authProviderId,
          roles: this.hasAdminRole(user) ? [] : ['LTN_ADMIN'],
        });
        this.loadUsers();
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: 'An error occurred, please try again later',
        });
      } finally {
        this.loadingBtn = false;
      }
    },
  },
  created() {
    this.loadUsers();
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/User/UsersList.vue